import { getCustomProperties } from './api';

export const CUSTOM_PRODUCT_PROPERTIES = {
  cacheKey: 'CUSTOM_PRODUCT_PROPERTIES',
  apiFunction: getCustomProperties
};
